import { useRef, useEffect } from 'react';

interface UseTabVisibilityGuardOptions {
  enabled: boolean;
  onTabHidden: () => void;
}

export function useTabVisibilityGuard({
  enabled,
  onTabHidden,
}: UseTabVisibilityGuardOptions): void {
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (!enabled) return undefined;

    const handleVisibilityChange = () => {
      if (document.hidden && !hasTriggered.current) {
        hasTriggered.current = true;
        onTabHidden();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [enabled, onTabHidden]);
}
